<template>
  <div class="task">
    <div class="task-img">
      <div class="task-this">
        <span style="font-size: 24px">当前积分</span>
        <span style="font-size: 38px">{{score.currentScore}}</span>
      </div>
      <div class="task-text">
        <span>今天获得：</span>
        <span>{{score.todayScore}}</span>
      </div>
      <div class="task-text" style="margin-left: 20px">
        <span>昨天获得：</span>
        <span v-if="score.yesterdayScore === null || score.yesterdayScore === undefined || score.yesterdayScore === 0">
          0</span>
        <span v-else>{{score.yesterdayScore}}</span>
      </div>
    </div>
    <div class="task-con">
      <div class="con-t">|&nbsp;&nbsp;&nbsp;任务墙</div>
      <div class="con-sign" v-if="this.tasks[2]?this.tasks[2].status === 1?true:false:false">
        <img src="../../assets/images/icon_check.png"/>
        <span>签到奖励</span>
        <span>已连续签到<b>{{sign.continuityDay}}</b>天</span>
        <span>累计签到<b>{{sign.total}}</b>天</span>
      </div>
      <div class="con-icon" v-if="this.tasks[2]?this.tasks[2].status === 1?true:false:false">
        <ul>
          <li>
            <div class="wrap" v-if="remainder >= 1 || (remainder === 0 && consult >= 1)">
              <div class="triangle-g"></div>
              <img src="../../assets/images/icon_c.png"/>
            </div>
            <div class="wrap-n" v-else-if="signIn === 1">
              <div class="triangle"></div>
              <img src="../../assets/images/icon_x.png"/>
            </div>
            <div class="wrap-no" v-else>
              <div class="triangle"></div>
              <img src="../../assets/images/icon_x.png"/>
            </div>
          </li>
          <li>
            <div class="wrap" v-if="remainder >= 2 || (remainder === 0 && consult >= 1)">
              <div class="triangle-g"></div>
              <img src="../../assets/images/icon_c.png"/>
            </div>
            <div class="wrap-n" v-else-if="signIn === 2">
              <div class="triangle"></div>
              <img src="../../assets/images/icon_x.png"/>
            </div>
            <div class="wrap-no" v-else>
              <div class="triangle"></div>
              <img src="../../assets/images/icon_x.png"/>
            </div>
          </li>
          <li>
            <div class="wrap" v-if="remainder >= 3 || (remainder === 0 && consult >= 1)">
              <div class="triangle-g"></div>
              <img src="../../assets/images/icon_c.png"/>
            </div>
            <div class="wrap-n" v-else-if="signIn === 3">
              <div class="triangle"></div>
              <img src="../../assets/images/icon_x.png"/>
            </div>
            <div class="wrap-no" v-else>
              <div class="triangle"></div>
              <img src="../../assets/images/icon_x.png"/>
            </div>
          </li>
          <li>
            <div class="wrap" v-if="remainder >= 4  || (remainder === 0 && consult >= 1)">
              <div class="triangle-g"></div>
              <img src="../../assets/images/icon_c.png"/>
            </div>
            <div class="wrap-n" v-else-if="signIn === 4">
              <div class="triangle"></div>
              <img src="../../assets/images/icon_x.png"/>
            </div>
            <div class="wrap-no" v-else>
              <div class="triangle"></div>
              <img src="../../assets/images/icon_x.png"/>
            </div>
          </li>
          <li>
            <div class="wrap" v-if="remainder >= 5 || (remainder === 0 && consult >= 1)">
              <div class="triangle-g"></div>
              <img src="../../assets/images/icon_c.png"/>
            </div>
            <div class="wrap-n" v-else-if="signIn === 5">
              <div class="triangle"></div>
              <img src="../../assets/images/icon_x.png"/>
            </div>
            <div class="wrap-no" v-else>
              <div class="triangle"></div>
              <img src="../../assets/images/icon_x.png"/>
            </div>
          </li>
          <li>
            <div class="wrap" v-if="remainder >= 6 || (remainder === 0 && consult >= 1)">
              <div class="triangle-g"></div>
              <img src="../../assets/images/icon_c.png"/>
            </div>
            <div class="wrap-n" v-else-if="signIn === 6">
              <div class="triangle"></div>
              <img src="../../assets/images/icon_x.png"/>
            </div>
            <div class="wrap-no" v-else>
              <div class="triangle"></div>
              <img src="../../assets/images/icon_x.png"/>
            </div>
          </li>
          <li>
            <div class="wrap" v-if="remainder === 0 && consult >= 1">
              <div class="triangle-g"></div>
              <img src="../../assets/images/icon_c.png"/>
            </div>
            <div class="wrap-n" v-else-if="signIn === 0">
              <div class="triangle"></div>
              <img src="../../assets/images/icon_x.png"/>
            </div>
            <div class="wrap-foot" v-else>
              <div class="triangle-foot"></div>
              <img src="../../assets/images/icon_gift.png"/>
            </div>
          </li>
          <li>
            <button class="signIn" @click="signs()" v-if="signFlag === false">签 到</button>
            <button class="info" v-else disabled>已 签 到</button>
          </li>
        </ul>
        <div style="clear: both"></div>
        <ol>
          <li>
            <div>第一日</div>
            <div>可获得{{this.tasks[2].award.content}}积分</div>
          </li>
          <li>
            <div>第二日</div>
            <div>可获得{{this.tasks[2].award.content}}积分</div>
          </li>
          <li>
            <div>第三日</div>
            <div>可获得{{this.tasks[2].award.content}}积分</div>
          </li>
          <li>
            <div>第四日</div>
            <div>可获得{{this.tasks[2].award.content}}积分</div>
          </li>
          <li>
            <div>第五日</div>
            <div>可获得{{this.tasks[2].award.content}}积分</div>
          </li>
          <li>
            <div>第六日</div>
            <div>可获得{{this.tasks[2].award.content}}积分</div>
          </li>
          <li>
            <div>第七日</div>
            <div>积分礼包</div>
          </li>
        </ol>
      </div>
      <div style="clear: both"></div>
      <div class="con-award" v-if="this.tasks[0].status === 1">
        <div><img src="../../assets/images/icon_recharge.png"/></div>
        <div>充值奖励</div>
        <div><img src="../../assets/images/icon_coin.png"/></div>
        <div>{{this.tasks[0].award.content}}积分</div>
        <div style="clear: both"></div>
        <div class="con-text">
          <span>今天账户完成，充值一笔超过{{this.tasks[0].award.top}}元的金额（该奖励有别于充值赠送）</span>
          <!--<span class="con-state">去联系专属客服</span>-->
        </div>
      </div>
      <div class="con-award" v-if="this.tasks[5].status === 1">
        <div><img src="../../assets/images/icon_consumption.png"/></div>
        <div>消费奖励</div>
        <div><img src="../../assets/images/icon_coin.png"/></div>
        <div>{{this.tasks[5].award.content}}积分</div>
        <div style="clear: both"></div>
        <div class="con-text">
          <span>本月账户完成，累计消费超过{{this.tasks[5].award.top}}元（该奖励有别于消费赠送）</span>
          <!--<span class="con-state">去联系专属客服</span>-->
        </div>
      </div>
      <div class="con-award" v-if="this.tasks[7].status === 1">
        <div><img src="../../assets/images/icon_read.png"/></div>
        <div>阅读奖励</div>
        <div><img src="../../assets/images/icon_coin.png"/></div>
        <div>{{this.tasks[7].award.content}}积分</div>
        <div style="clear: both"></div>
        <div class="con-text">
          <span>今天账户完成，阅读行业资讯（企业动态）内容、轮播图内容、网站三大产品线子产品内容</span>
          <span class="con-sta" v-if="award.read === true">已完成</span>
          <span class="con-stat" v-else>未完成</span>
        </div>
      </div>
      <div class="con-award" v-if="this.tasks[4].status === 1">
        <div><img src="../../assets/images/icon_show.png"/></div>
        <div>活动奖励</div>
        <div><img src="../../assets/images/icon_coin.png"/></div>
        <div>{{this.tasks[4].award.content}}积分</div>
        <div style="clear: both"></div>
        <div class="con-text">
          <span>今天账户完成，参与轮播图推荐的内容，有兑换商品（待小程序开发实现）</span>
          <span class="con-sta" v-if="award.activities === true">已完成</span>
          <span class="con-stat" v-else>未完成</span>
        </div>
      </div>
      <div class="con-award" v-if="this.tasks[8].status === 1">
        <div><img src="../../assets/images/icon_share.png"/></div>
        <div>分享奖励</div>
        <div><img src="../../assets/images/icon_coin.png"/></div>
        <div>{{this.tasks[8].award.content}}积分</div>
        <div style="clear: both"></div>
        <div class="con-text">
          <span>今天账户完成，通过页面的分享功能，分享行业资讯（企业动态）内容、网站三大产品线子产品内容</span>
          <span class="con-sta" v-if="award.share === true">已完成</span>
          <span class="con-stat" v-else>未完成</span>
        </div>
      </div>
      <div class="con-award" v-if="this.tasks[3].status === 1">
        <div><img src="../../assets/images/icon_qudao.png"/></div>
        <div>官方奖励</div>
        <div><img src="../../assets/images/icon_coin.png"/></div>
        <div>{{this.tasks[3].award.content}}积分</div>
        <div style="clear: both"></div>
        <div class="con-text">
          <span>今天账户完成，通过留言功能进行意见反馈，并得到渠道无忧官方认可</span>
          <span class="con-sta" v-if="award.officialAward === true">已完成</span>
          <span class="con-stat" v-else>未完成</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Api from '@/api/client/task-wall'
  import moment from 'moment'
  export default {
    data () {
      return {
        signFlag: false,
        score: [],
        sign: [],
        award: [],
        remainder: '',
        consult: '',
        signIn: '',
        tasks: []
      }
    },
    created () {
      this.requestList()
      this.requestSign()
      this.requestAward()
      Api.taskList(response => {
        let status = response.data.code
        let body = response.data
        if (status === '200') {
          this.tasks = body.data
        } else {
          this.score = []
        }
      })
    },
    methods: {
      signs () {
        Api.signIn(response => {
          let status = response.data.code
          let body = response.data.data
          if (status === '200') {
            this.remainder = body.continuityDay % 7
            this.consult = body.continuityDay / 7
            this.requestList()
            this.requestSign()
            this.requestAward()
            this.$message.success('签到成功')
            this.signFlag = true
          } else {
            this.signFlag = false
            this.$message.error(body.msg || '签到失败')
          }
        })
      },
      requestList () {
        Api.scoreList(response => {
          let status = response.data.code
          let body = response.data.data
          if (status === '200') {
            this.score = body
          } else {
            this.score = []
          }
        })
      },
      requestSign () {
        Api.signList(response => {
          let status = response.data.code
          let body = response.data.data
          if (status === '200') {
            this.sign = body
            this.remainder = body.continuityDay % 7
            this.consult = body.continuityDay / 7
            let myDate = moment().format('YYYY-MM-DD')
            if (myDate !== body.startTime) {
              this.signIn = this.remainder + 1
            } else {
              this.signFlag = true
            }
          } else {
            this.sign = []
          }
        })
      },
      requestAward () {
        Api.awardList(response => {
          let status = response.data.code
          let body = response.data.data
          if (status === '200') {
            this.award = body
          } else {
            this.award = []
          }
        })
      }
    }
  }
</script>

<style scoped="scoped" lang="scss">
  @import '../../assets/styles/_env.scss';
  .task{
    width: 100%;
    height: 100%;
    .task-img{
      width: 100%;
      height: 116px;
      background: url('../../assets/images/task.png') no-repeat;
      background-size: 100% auto;
      padding: 15px 0 0 216px;
      box-sizing: border-box;
      .task-this{
        font-weight: bold;
        color: white;
      }
      .task-text{
        color: white;
        font-size: 16px;
        float: left;
      }
    }
    .task-con{
      width: 100%;
      min-height: 880px;
      background: white;
      border: 1px solid $color-cut-line;
      margin-top: 20px;
      padding: 20px 30px;
      box-sizing: border-box;
      .con-t{
        color: $color-main;
        font-size: $font-main;
        font-weight: bold;
        margin-bottom: 5px;
      }
      .con-sign{
        width: 100%;
        height: 84px;
        line-height: 84px;
        >img{
          float: left;
          margin: 20px 10px 0 10px;
        }
        >span{
          float: left;
          >b{
            font-size: 16px;
            margin: 0 10px;
            color: $color-main;
          }
        }
        span:nth-child(2){
          font-size: 16px;
          color: #333;
        }
        span:nth-child(3){
          margin: 0 30px 0 74px;
          font-size: 14px;
          color: #666;
        }
        span:nth-child(4){
          font-size: 14px;
          color: #666;
        }
      }
      .con-icon{
        width: 1008px;
        height: 84px;
        background: #f9f9f9;
        margin-left: -30px;
        >ul{
          list-style: none;
          padding: 16px 0 0 46px;
          box-sizing: border-box;
          >li{
            width: 50px;
            height: 50px;
            float: left;
            margin-right: 40px;
            .wrap{
              width: 50px;
              height: 50px;
              position: relative;
              background:rgba(28,211,136,1);
              box-shadow:0px 2px 10px 0px rgba(28,211,136,1);
              -ms-box-shadow: 0px 2px 10px 0px rgba(28,211,136,1);
              -moz-box-shadow: 0px 2px 10px 0px rgba(28,211,136,1);
              -webkit-box-shadow: 0px 2px 10px 0px rgba(28,211,136,1);
              -o-box-shadow: 0px 2px 10px 0px rgba(28,211,136,1);
              >img{
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                margin: auto;
              }
              .triangle-g{
                width: 10px;
                height: 10px;
                background: rgba(28,211,136,1);
                transform:rotate(45deg);
                -ms-transform:rotate(45deg); 	/* IE 9 */
                -moz-transform:rotate(45deg); 	/* Firefox */
                -webkit-transform:rotate(45deg); /* Safari 和 Chrome */
                -o-transform:rotate(45deg);
                position: absolute;
                bottom: -5px;
                left: 0;
                right: 0;
                margin: auto;
              }
            }
            .wrap-n{
              width: 50px;
              height: 50px;
              background:rgba(38,114,255,1);
              box-shadow:0px 2px 10px 0px rgba(60,154,255,1);
              -ms-box-shadow: 0px 2px 10px 0px rgba(60,154,255,1);
              -moz-box-shadow: 0px 2px 10px 0px rgba(60,154,255,1);
              -webkit-box-shadow: 0px 2px 10px 0px rgba(60,154,255,1);
              -o-box-shadow: 0px 2px 10px 0px rgba(60,154,255,1);
              position: relative;
              >img{
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                margin: auto;
              }
              .triangle{
                width: 10px;
                height: 10px;
                background:rgba(38,114,255,1);
                box-shadow:0px 2px 10px 0px rgba(60,154,255,1);
                -ms-box-shadow: 0px 2px 10px 0px rgba(60,154,255,1);
                -moz-box-shadow: 0px 2px 10px 0px rgba(60,154,255,1);
                -webkit-box-shadow: 0px 2px 10px 0px rgba(60,154,255,1);
                -o-box-shadow: 0px 2px 10px 0px rgba(60,154,255,1);
                transform:rotate(45deg);
                -ms-transform:rotate(45deg); 	/* IE 9 */
                -moz-transform:rotate(45deg); 	/* Firefox */
                -webkit-transform:rotate(45deg); /* Safari 和 Chrome */
                -o-transform:rotate(45deg);
                position: absolute;
                bottom: -5px;
                left: 0;
                right: 0;
                margin: auto;
              }
            }
            .wrap-no{
              width: 50px;
              height: 50px;
              background: #d2d2d2;
              position: relative;
              >img{
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                margin: auto;
              }
              .triangle{
                width: 10px;
                height: 10px;
                background: #d2d2d2;
                transform:rotate(45deg);
                -ms-transform:rotate(45deg); 	/* IE 9 */
                -moz-transform:rotate(45deg); 	/* Firefox */
                -webkit-transform:rotate(45deg); /* Safari 和 Chrome */
                -o-transform:rotate(45deg);
                position: absolute;
                bottom: -5px;
                left: 0;
                right: 0;
                margin: auto;
              }
            }
          }
          .wrap-foot{
            width: 50px;
            height: 50px;
            position: relative;background:rgba(239,197,50,1);
            box-shadow:0px 2px 10px 0px rgba(239,197,50,1);
            -ms-box-shadow: 0px 2px 10px 0px rgba(239,197,50,1);
            -moz-box-shadow: 0px 2px 10px 0px rgba(239,197,50,1);
            -webkit-box-shadow: 0px 2px 10px 0px rgba(239,197,50,1);
            -o-box-shadow: 0px 2px 10px 0px rgba(239,197,50,1);
            >img{
              position: absolute;
              top: 0;
              bottom: 0;
              right: 0;
              left: 0;
              margin: auto;
            }
            .triangle-foot{
              width: 10px;
              height: 10px;
              transform:rotate(45deg);
              -ms-transform:rotate(45deg); 	/* IE 9 */
              -moz-transform:rotate(45deg); 	/* Firefox */
              -webkit-transform:rotate(45deg); /* Safari 和 Chrome */
              -o-transform:rotate(45deg);
              position: absolute;
              bottom: -5px;
              left: 0;
              right: 0;
              margin: auto;
              background:rgba(239,197,50,1);
              box-shadow:0px 2px 10px 0px rgba(239,197,50,1);
            }
          }
          >li:nth-child(8){
            background: #f9f9f9;
            .signIn{
              width:80px;
              height:30px;
              background:rgba(38,114,255,1);
              border-radius:4px;
              border: none;
              outline: none;
              color: white;
              font-size: 14px;
              cursor: pointer;
              margin: 8px 0 0 60px;
              &:hover {
                background: #4a98ff;
                transition-duration: 0.5s;
              }
            }
            .info{
              width:80px;
              height:30px;
              background:#d2d2d2;
              border-radius:4px;
              border: none;
              outline: none;
              color: white;
              font-size: 14px;
              margin: 8px 0 0 60px;
              cursor: no-drop;
            }
          }
        }
        >ol{
          width: 100%;
          height: 60px;
          list-style: none;
          padding: 10px 0 0 46px;
          box-sizing: border-box;
          >li{
            width: 50px;
            float: left;
            margin-right: 40px;
            text-align: center;

            div:nth-child(1){
              color: #333;
              font-size: 14px;
            }
            div:nth-child(2){
              color: #999;
              font-size: 12px;
            }
          }
        }
      }
      .con-award{
        width: 100%;
        height: 110px;
        border-bottom: 1px solid $color-cut-line;
        margin-top: 5px;
        padding: 0 0 10px 0;
        div:nth-child(1){
          float: left;
          margin: 20px 10px 0 10px;
        }
        div:nth-child(2){
          float: left;
          margin: 30px 10px 0 10px;
          font-size: 16px;
          color: #333;
        }
        div:nth-child(3){
          float: left;
          font-size: 16px;
          color: #333;
          margin: 35px 5px 0 10px;
        }
        div:nth-child(4){
          float: left;
          font-size: 12px;
          color: #999;
          margin: 35px 10px 0 0;
        }
        .con-text{
          height: 30px;
          font-size: 14px;
          padding:10px 0 0 10px;
          box-sizing: border-box;
          >span:nth-child(1){
            font-size: 14px;
            color: #333;
          }
          .con-state{
            height: 16px;
            display: block;
            float: right;
            margin-right: 10px;
            color: #085ECC;
            border-bottom: 1px solid #085ECC;
            &:hover{
              cursor: pointer;


            }
          }
          .con-stat{
            float: right;
            margin-right: 10px;
            color: #085ECC;
          }
          .con-sta{
            float: right;
            margin-right: 10px;
            color: #666;
          }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/TaskWall.vue